<template>
    <v-dialog
            scrollable
            v-model="visible"
            max-width="900px"
            :fullscreen="fullscreen"
            :persistent="true">
        <v-card>
            <v-toolbar flat dense>
                <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="fullscreen=!fullscreen">
                    <v-icon>fullscreen</v-icon>
                </v-btn>
            </v-toolbar>

            <v-divider style="max-height: 1px"/>
            <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

            <v-card-text>
                <v-form v-model="formValid" ref="formRef">
                    <v-container grid-list-md>
                        <v-layout wrap>

                            <v-flex xs12>
                                <v-autocomplete
                                        label="预算模板"
                                        :rules="rules.required"
                                        v-model="item.budgetTplId"
                                        item-text="name"
                                        item-value="dbid"
                                        :items="tplItems"
                                        :search-input.sync="tplSearch"
                                        @change="onTplChange"
                                />
                            </v-flex>

                            <v-flex xs12>
                                <v-data-table
                                        class="dense"
                                        :headers="headers"
                                        :items="item.budgetItems"
                                        hide-actions
                                        :loading="fundLoading">
                                    <template slot="items" slot-scope="props">
                                        <td>{{ props.index + 1}}</td>
                                        <td>
                                            <span :style="`padding-left: ${props.item.level-1}em`">
                                            {{props.item.tplName}}
                                            </span>
                                        </td>
                                        <td v-if="props.item.leaf">
                                            <v-text-field
                                                    :key="props.item.dbid"
                                                    v-model="item.budgetItems[props.index].amount"
                                                    :rules="rules.amount"
                                                    @change="onLeafItemChange"
                                            />
                                        </td>
                                        <td v-else>
                                            {{props.item.amount | currency}}
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-flex>

                            <v-flex xs12>
                                <v-text-field
                                        label="备注"
                                        v-model="item.note"
                                        :rules="rules.note"
                                />
                            </v-flex>

                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
                <v-btn color="primary" @click.native="onSave">保存
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

    import mixin from '@/mixin'

    const baseURI = '/api/proj/budget-item';
    const tplURI = '/api/proj/budget-template';

    export default {
        mixins: [mixin.edit(baseURI)],
        props: ['value', "dbid", 'projTypeId', 'projectId'],
        components: {},

        data() {
            return {
                formValid: false,

                item: {},
                freshItem: {
                    "projectId": null,
                    "budgetTplId": null,
                    "amount": 0.0,
                    "rank": 0,
                    "budgetItems": []
                },

                headers: [
                    {text: '#', sortable: false, value: 'rank', width: 18},
                    {text: '科目', sortable: false, value: 'tpl_name'},
                    {text: '经费（万元）', sortable: false, value: 'amount', width: 200},
                    // {text: '备注', sortable: false, value: 'note', width: 230},
                ],

                paymentDateMenu: false,
                paymentDate: null,

                tplSearch: '',
                tplItems: [],

                fundLoading: false,

                /**
                 * 验证规则
                 */
                rules: {
                    name: [
                        v => !!v || '必填项。',
                        v => (v && v.length <= 150) || '长度必须小于150个字符。'
                    ],
                    required: [
                        v => !!v || '必填项。'
                    ],
                    amount: [
                        v => (!!v || v == 0) || '必填项。',
                        v => (/^\d+?(\.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。'
                    ],
                    note: [v => (!v || v.length <= 255) || '长度必须小于255个字符。']
                }
            }
        },

        watch: {
            projTypeId(v) {
                if (!v) return;
                this.axios.get(tplURI, {
                    params: {limit: 65535, typeId: v, sort: 'rank.asc'}
                    // params: {limit: 65535, sort: 'rank.asc'}
                }).then(
                    rsp => this.tplItems = rsp.data.items
                )
            },
            dbid(v) {
                if (!v) return;
                this.axios.get(`${baseURI}/${v}`).then(
                    rsp => this.tplItems = rsp.data.items
                )
            },
            tplSearch(v) {
                this.onTplSearch(v);
            }
        },

        methods: {
            get() {
                const vm = this;

                vm.loading = true;
                this.axios.get(`${baseURI}/${this.dbid}`)
                    .then(rsp => {
                        if (this.afterGetData) {
                            this.afterGetData(rsp.data)
                        }

                        // 填充编辑对话框
                        if (rsp.data.length > 0) {
                            vm.item = rsp.data.shift();
                            vm.item.budgetItems = rsp.data;
                        }

                        // 保存默认数据
                        // vm.defaultItem = window.xutil.clone(vm.item);
                        vm.loading = false;
                    });
            },
            onTplSearch() {
                // window.console.log("in tplSearch");
                this.axios.get(tplURI, {
                    params: {limit: 65535, typeId: this.projTypeId, sort: 'rank.asc'}
                    // params: {limit: 65535, sort: 'rank.asc'}
                }).then(rsp => {
                    this.tplItems = rsp.data.items
                })
            },

            onTplChange(v, ov) {
                // window.console.log(`in onTplChange， v: ${v}, ov:${ov}`);

                // 新建
                if (!ov && v && this.item.budgetItems.length === 0) {
                    // window.console.log(`in onTplChange， new`);
                    this.axios.get(`${tplURI}/detail/${v}`)
                        .then(rsp =>
                            this.top2down(v, rsp.data.map(v => {
                                return {
                                    "budgetTplId": v.dbid,
                                    "tplParentId": v.parentId,
                                    "tplName": v.name,
                                    "rank": v.rank,
                                    "level": v.level,
                                    "leaf": v.leaf
                                }
                            }))
                        )
                }

            },

            onLeafItemChange() {
                // window.console.log("in onLeafItemChange");
                this.$refs.formRef.validate();
                this.top2down(this.item.budgetTplId, this.item.budgetItems)
                // window.console.log("in onLeafItemChange");
            },

            top2down(tplId, tplItems) {
                if (!tplId) return;

                const am = {}; // 父节点经费
                am[tplId] = Number(0.0);

                // tplItems = window.xutil.clone(tplItems);
                // this.item.budgetItems = [];
                this.item.budgetItems = tplItems.reverse().map(
                    v => {
                        if (v.leaf) {
                            if (v.amount === undefined) {
                                v.amount = 0.0;
                            }
                        } else {
                            v.amount = am[v.budgetTplId]
                        }

                        // 累加父节点金额
                        if (am[v.tplParentId] === undefined)
                            am[v.tplParentId] = Number(v.amount);
                        else
                            am[v.tplParentId] = Number(am[v.tplParentId]) + Number(v.amount);

                        return v;
                    }
                ).reverse();
                this.item.amount = am[tplId];
                this.$forceUpdate();
            },

            beforeSendData(data) {
                data.projectId = this.projectId
            }
        }
    }
</script>
